import styled, { keyframes } from 'styled-components';

const fadeInUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const gradientShift = keyframes`
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
`;

export const EssencePageContainer = styled.div`
    padding: 2rem;
    position: relative;
    overflow: hidden;
    z-index: 1;
    min-height: 100vh;

    &::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('/img/LogoDuoaColor.png');
        background-size: 400px;
        background-repeat: repeat;
        background-position: center;
        opacity: 0.05;
        z-index: -1;
    }

    @media (max-width: 768px) {
        padding: 1rem;
    }
`;

export const EssenceHero = styled.div`
    text-align: center;
    padding: 3rem 0 4rem;
    animation: ${fadeInUp} 0.8s ease-out;

    @media (max-width: 768px) {
        padding: 2rem 0 3rem;
    }
`;

export const HeroSubtitle = styled.p`
    font-size: 1.3rem;
    color: rgba(255, 255, 255, 0.8);
    max-width: 700px;
    margin: 1rem auto 0;
    line-height: 1.6;

    @media (max-width: 768px) {
        font-size: 1.1rem;
    }
`;

export const EssenceSection = styled.section`
    display: flex;
    align-items: center;
    gap: 4rem;
    max-width: 1200px;
    margin: 0 auto 6rem;
    padding: 0 1rem;
    flex-direction: ${props => props.reverse ? 'row-reverse' : 'row'};
    animation: ${fadeInUp} 0.8s ease-out ${props => props.delay || '0.2s'} both;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 2rem;
        margin-bottom: 4rem;
    }
`;

export const EssenceContent = styled.div`
    flex: 1;
    min-width: 0;

    @media (max-width: 768px) {
        order: 2;
    }
`;

export const SectionHeading = styled.h2`
    font-size: 2rem;
    margin-bottom: 1.5rem;
    background: linear-gradient(135deg, #ff6b8b, #6b5bff, #4ecdc4);
    background-size: 200% 200%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: ${gradientShift} 3s ease infinite;
    font-weight: 700;
    line-height: 1.3;

    @media (max-width: 768px) {
        font-size: 1.5rem;
        text-align: center;
    }
`;

export const SectionText = styled.p`
    color: rgba(255, 255, 255, 0.85);
    font-size: 1.1rem;
    line-height: 1.8;
    margin-bottom: 1rem;

    &:last-child {
        margin-bottom: 0;
    }

    @media (max-width: 768px) {
        font-size: 1rem;
        text-align: center;
    }
`;

export const EssenceImageWrapper = styled.div`
    flex: 1;
    min-width: 0;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);
    transition: all 0.5s ease;

    &:hover {
        transform: scale(1.02);
        box-shadow: 0 25px 50px rgba(107, 91, 255, 0.3);
    }

    @media (max-width: 768px) {
        order: 1;
        width: 100%;
        max-width: 400px;
        margin: 0 auto;
    }
`;

export const EssenceImage = styled.img`
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
`;
